module.exports = __webpack_public_path__ + "static/12.4_classical_greece-c66e11bcbc5c8682459e50e7e2bcaadc.pdf";